import { render, staticRenderFns } from "./PropertyColor.vue?vue&type=template&id=1f6a7a35"
import script from "./PropertyColor.vue?vue&type=script&lang=js"
export * from "./PropertyColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports